import React, { useEffect, useRef, useState } from "react";
import EditPicButton from "components/General-UI/EditPicButton";
import { useDispatch, useSelector } from "react-redux";
import {
  selectEditRootError,
  selectRootIcon,
  selectRootName,
  selectTryingEditRoot,
  setPictureFile,
  editRootIconConfirm,
  setRootIcon,
  setNewRootModal,
  setRootName,
} from "slices/homeStartSlice";
import Upload from "graphics/icons/Upload";
import EfficeIconLarge from "components/General-UI/EfficeIconLarge";
import Modal from "components/HOCS/Modal";

const RootIconEditModal = ({ currentActiveEffice, onExit }) => {
  const inputElement = useRef();
  const dispatch = useDispatch();
  const rootName = useSelector(selectRootName);
  const rootIcon = useSelector(selectRootIcon);
  const tryingEditRoot = useSelector(selectTryingEditRoot);
  const editRootError = useSelector(selectEditRootError);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(setRootIcon(currentActiveEffice.avatar_key));
    dispatch(setRootName(currentActiveEffice.content));
    return () => {
      dispatch(setNewRootModal({ status: null }));
    };
  }, [currentActiveEffice, dispatch]);

  return (
    <Modal
      onDismiss={() => {
        onExit();
      }}
      lightBackDrop={false}
      growth={false}
      header={"Edit Effice Icon"}
      content={
        <div className={`text-nowrap`}>
          <div className="d-inline-block w-100">
            <br></br>
            <input
              style={{ display: "none" }}
              type="file"
              onChange={(e) => {
                dispatch(setPictureFile(e.target.files[0]));
              }}
              ref={inputElement}
              accept="image/*"
            />
            <div className="d-flex justify-content-around">
              <EditPicButton
                disabledOn={tryingEditRoot}
                text="Upload New"
                onClick={() => inputElement.current.click()}
              >
                <Upload />
              </EditPicButton>
              <div className="d-grid">
                <EfficeIconLarge rootIcon={rootIcon} rootName={rootName} />
                {rootIcon ? (
                  <div
                    className="mx-auto mt-1 d-inline align-middle cursor-pointer"
                    onClick={() => {
                      dispatch(setPictureFile(null));
                    }}
                  >
                    Remove
                  </div>
                ) : null}
              </div>
            </div>
            <div>
              <br></br>
              <button
                onClick={() => {
                  if (!loading) {
                    setLoading(true);
                    dispatch(editRootIconConfirm(currentActiveEffice.id))
                      .then(() => {
                        setLoading(false);
                        onExit();
                      })
                      .catch(() => {
                        setLoading(false);
                      });
                  }
                }}
                type="submit"
                className="confirm-button growth-button mt-1"
                disabled={loading || tryingEditRoot}
              >
                {loading ? "Confirming..." : "Confirm"}
              </button>
              <div className="server-response-error">{editRootError}</div>
            </div>
          </div>
        </div>
      }
      actions={null}
      noBackDropClick={false}
      containerClass="signInUpFormBox"
    />
  );
};

export default RootIconEditModal;
